export default __webpack_public_path__ + "static/media/layer3.949c2bcb.webp";